import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { title: String }; // data-title-title-value を受け取る

  connect() {
    if (this.hasTitleValue) {
      document.title = this.titleValue; // タブのタイトルを即座に更新
    }
  }
}
